export const MainStep = {
  VORAUSWAHL: "Vorauswahl",
  FÜHRERSCHEINKLASSEN: "Führerscheinklassen",
  TERMIN: "Termin",
  PERSÖNLICHEDATEN: "Persönliche Daten",
  ÜBERPRÜFEN: "Überprüfen",
};

export const DetailStep = {
  VORAUSWAHL_START: "Vorauswahl_Start",
  VORAUSWAHL_FÜHRERSCHEIN: "Vorauswahl_Führerschein",
  VORAUSWAHL_FÜHRERSCHEIN_DATEN: "Vorauswahl_Führerschein_Daten",
  VORAUSWAHL_FREIWILLIG: "Vorauswahl_Freiwillig",
  FAHRZEUGTYP: "Fahrzeugtyp",
  FÜHRERSCHEINKLASSEN: "Führerscheinklassen",
  TERMIN: "Termin",
  TERMIN_STANDORT: "Termin_Standort",
  TERMIN_LEIHFAHRZEUG: "Termin_Leihfahrzeug",
  PERSÖNLICHEDATEN: "Persönliche_Daten",
  ÜBERPRÜFEN: "Überprüfen",
  DONE: "Done",
};

export const firstStep = DetailStep.VORAUSWAHL_START;
export const lastStep = DetailStep.DONE;

export const VorauswahlInteresse = {
  FÜHRERSCHEIN: "Führerschein",
  FAHRSICHERHEITSTRAINING: "Fahrsicherheitstraining",
};

export const VorauswahlFreiwillig = {
  JA: "Ja, freiwillig",
  NEIN: "Nein, aufgrund Mehrphasenausbildung",
};

export const FahrzeugTyp = {
  A: "A",
  B: "B",
};

export const JaNein = {
  JA: "Ja",
  NEIN: "Nein",
};

export const Navigation = {
  WEITER: "Weiter",
  ZURÜCK: "Zurück",
};

export const VorauswahlFührerschein = {
  JA: "Ja",
  JANURMOPED: "Ja, nur Moped (AM)",
  NEIN: "Nein",
};

export const FührerscheinKlassen = {
  A: "A",
  A2: "A2",
  A1: "A1",
  CODE111: "Code 111",
  B: "B",
  BL17: "B L17",
  BDUAL: "B Dual",
  C: "C",
  CE: "CE",
  C1: "C1",
  EZUB: "E zu B",
  EZUBWENNF: "E zu B bei Besitz von F",
  CODE96: "Code 96",
  EZUC: "E zu C",
  F: "F",
  AM: "AM",
};

export const FührerscheinKlassenSuper = {
  A: "A",
  AM: "AM",
  B: "B",
  C: "C",
  E: "E",
  F: "F",
  BE: "BE",
  KEINKURS_CODE111: "KEINKURS_CODE111", // wenn nichts matchen soll
  KEINKURS_EZUBWENNF: "KEINKURS_EZUBWENNF" // wenn nichts matchen soll
} 